import { UpdateClientApplicationForm } from "@components/Forms";

import { Card } from "@design-system/Card/Card";

type Props = {
  clientId: string;
  clientApplicationId: string;
};

export const ClientApplicationCard = ({
  clientId,
  clientApplicationId,
}: Props) => {
  return (
    <Card>
      <Card.Header>
        <Card.Header.Title>Record</Card.Header.Title>
      </Card.Header>
      <Card.Body>
        <UpdateClientApplicationForm
          clientId={clientId}
          clientApplicationId={clientApplicationId}
          withSubmitButton={false}
          disabled
        />
      </Card.Body>
    </Card>
  );
};
